export const PERIOD_TODAY = "TODAY";
export const PERIOD_YESTERDAY = "YESTERDAY";
export const PERIOD_THIS_WEEK = "THIS_WEEK";
export const PERIOD_LAST_WEEK = "LAST_WEEK";
export const PERIOD_LAST_7_DAYS = "LAST_7_DAYS";
export const PERIOD_LAST_14_DAYS = "LAST_14_DAYS";
export const PERIOD_LAST_30_DAYS = "LAST_30_DAYS";
export const PERIOD_THIS_MONTH = "THIS_MONTH";
export const PERIOD_THIS_MONTH_TILL_YESTERDAY = "THIS_MONTH_TILL_YESTERDAY";
export const PERIOD_LAST_MONTH = "LAST_MONTH";
export const PERIOD_LAST_3_MONTHS = "LAST_3_MONTHS";
export const PERIOD_LAST_6_MONTHS = "LAST_6_MONTHS";
export const PERIOD_THIS_PERIOD = "THIS_PERIOD";
export const PERIOD_THIS_PERIOD_TILL_YESTERDAY = "THIS_PERIOD_TILL_YESTERDAY";
export const PERIOD_7_DAYS_BEFORE = "7_DAYS_BEFORE";
export const PERIOD_14_DAYS_BEFORE = "14_DAYS_BEFORE";
export const PERIOD_LAST_YEAR = "LAST_YEAR";
export const PERIOD_SAME_PERIOD_LAST_YEAR = "SAME_PERIOD_LAST_YEAR";
export const PERIOD_PREVIOUS_PERIOD = "PREVIOUS_PERIOD";

export const ALL_PERIODS = [PERIOD_TODAY, PERIOD_YESTERDAY, PERIOD_THIS_WEEK, PERIOD_LAST_WEEK, PERIOD_LAST_7_DAYS, PERIOD_LAST_14_DAYS, PERIOD_LAST_30_DAYS,
    PERIOD_THIS_MONTH, PERIOD_THIS_MONTH_TILL_YESTERDAY, PERIOD_LAST_MONTH, PERIOD_THIS_PERIOD, PERIOD_THIS_PERIOD_TILL_YESTERDAY,
    PERIOD_LAST_3_MONTHS, PERIOD_LAST_6_MONTHS, PERIOD_LAST_YEAR, PERIOD_7_DAYS_BEFORE, PERIOD_14_DAYS_BEFORE, PERIOD_SAME_PERIOD_LAST_YEAR];

export const getPropertiesForPeriod = (t) => ({
    [PERIOD_TODAY]: {'name': t('periods.today'), 'depends_of_other_period': false},
    [PERIOD_YESTERDAY]: {'name': t('periods.yesterday'), 'depends_of_other_period': false},
    [PERIOD_THIS_WEEK]: {'name': t('periods.this_week'), 'depends_of_other_period': false},
    [PERIOD_LAST_WEEK]: {'name': t('periods.last_week'), 'depends_of_other_period': false},
    [PERIOD_LAST_7_DAYS]: {'name': t('periods.last_7_days'), 'depends_of_other_period': false},
    [PERIOD_LAST_14_DAYS]: {'name': t('periods.last_14_days'), 'depends_of_other_period': false},
    [PERIOD_LAST_30_DAYS]: {'name': t('periods.last_30_days'), 'depends_of_other_period': false},
    [PERIOD_THIS_MONTH]: {'name': t('periods.this_month'), 'depends_of_other_period': false},
    [PERIOD_THIS_MONTH_TILL_YESTERDAY]: {'name': t('periods.this_month_till_yesterday'), 'depends_of_other_period': false},
    [PERIOD_LAST_MONTH]: {'name': t('periods.last_month'), 'depends_of_other_period': false},
    [PERIOD_THIS_PERIOD]: {'name': t('periods.control_line_period'), 'depends_of_other_period': false},
    [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: {'name': t('periods.control_line_period_until_yesterday'), 'depends_of_other_period': false},
    [PERIOD_LAST_3_MONTHS]: {'name': t('periods.last_3_months'), 'depends_of_other_period': false},
    [PERIOD_LAST_6_MONTHS]: {'name': t('periods.last_6_months'), 'depends_of_other_period': false},
    [PERIOD_7_DAYS_BEFORE]: {'name': t('periods.7_days_before'), 'depends_of_other_period': true},
    [PERIOD_14_DAYS_BEFORE]: {'name': t('periods.14_days_before'), 'depends_of_other_period': true},
    [PERIOD_LAST_YEAR]: {'name': t('periods.last_year'), 'depends_of_other_period': false},
    [PERIOD_SAME_PERIOD_LAST_YEAR]: {'name': t('periods.same_period_last_year'), 'depends_of_other_period': true},
    [PERIOD_PREVIOUS_PERIOD]: {'name': t('periods.previous_period'), 'depends_of_other_period': true},
});

// Keep the old export for backward compatibility
export const PROPERTIES_FOR_PERIOD = getPropertiesForPeriod;

export const BU_PERIOD_PERIODIC = 'PERIODIC'
export const BU_PERIOD_TEMPORARY = 'TEMPORARY'

export const getPropertiesForBuPeriod = (t) => ({
    [BU_PERIOD_PERIODIC]: {'name': t('periods.monthly')},
    [BU_PERIOD_TEMPORARY]: {'name': t('periods.temporary')}
});

// Keep the old export for backward compatibility
export const PROPERTIES_FOR_BU_PERIOD = getPropertiesForBuPeriod;

export const ALERT_SNOOZE_PERIOD_TODAY= 'TODAY'
export const ALERT_SNOOZE_PERIOD_ONE_WEEK = 'ONE_WEEK'
export const ALERT_SNOOZE_PERIOD_THIS_MONTH = 'THIS_MONTH'
export const ALERT_SNOOZE_PERIOD_FOREVER = 'FOREVER'

export const getAlertSnoozePeriodDataByPeriod = (t) => ({
    [ALERT_SNOOZE_PERIOD_TODAY]: {
        "name": t('periods.today'),
        "silenceFor": t('periods.silence_for_today')
    },
    [ALERT_SNOOZE_PERIOD_ONE_WEEK]: {
        "name": t('periods.one_week'),
        "silenceFor": t('periods.silence_for_one_week')
    },
    [ALERT_SNOOZE_PERIOD_THIS_MONTH]: {
        "name": t('periods.this_month'),
        "silenceFor": t('periods.silence_for_this_month')
    },
    [ALERT_SNOOZE_PERIOD_FOREVER]: {
        "name": t('periods.forever'),
        "silenceFor": t('periods.silence_forever')
    },
});

// Utility function to get period name using react-i18next
export const getPeriodName = (period, t) => {
    const properties = getPropertiesForPeriod(t);
    return properties[period]?.name || period;
};

// Utility function to get BU period name using react-i18next
export const getBuPeriodName = (period, t) => {
    const properties = getPropertiesForBuPeriod(t);
    return properties[period]?.name || period;
};

// Utility function to get alert snooze period name using react-i18next
export const getAlertSnoozePeriodName = (period, t) => {
    const properties = getAlertSnoozePeriodDataByPeriod(t);
    return properties[period]?.name || period;
};

// Utility function to get alert snooze silence text using react-i18next
export const getAlertSnoozeSilenceText = (period, t) => {
    const properties = getAlertSnoozePeriodDataByPeriod(t);
    return properties[period]?.silenceFor || '';
};

/*
Usage Example in a React component:

import { getPeriodName, getPropertiesForPeriod } from '../periods';
import { withTranslation } from 'react-i18next';

class MyComponent extends Component {
    render() {
        const { t } = this.props;
        const period = 'TODAY';
        
        // Get period description using react-i18next
        const periodText = getPeriodName(period, t);
        
        // Or get full properties
        const properties = getPropertiesForPeriod(t);
        const periodData = properties[period];
        
        return (
            <div>
                <p>Selected period: {periodText}</p>
                <p>Depends on other period: {periodData.depends_of_other_period ? 'Yes' : 'No'}</p>
            </div>
        );
    }
}

export default withTranslation()(MyComponent);
*/
